import type React from 'react';
import type { Attribute } from '@shared/types/cart';
// import { Attribute } from 'library/types/cart';

import * as st from './styles.module.scss';

interface Props {
  attributes: Attribute[];
}

export const Attributes: React.FC<Props> = ({ attributes }) => {
  return (
    <>
      {attributes.map((attribute) => {
        if (attribute.type === 'color') {
          return (
            <>
              <div key={attribute.id} className={st.attribute__title}>
                {attribute.title}
              </div>
              <div
                className={st.color}
                style={{
                  boxShadow: `0 0 0 2px #${attribute.value}`,
                }}
              >
                <div
                  className={st.color__background}
                  style={{
                    backgroundColor: `#${attribute.value}`,
                    boxShadow: `0 0 0 1px #fff`,
                  }}
                ></div>
              </div>
            </>
          );
        }

        return (
          <>
            <div className={st.attribute__title}>{attribute.title}:</div>
            <div className={st.attribute__value}>{attribute.value}</div>
          </>
        );
      })}
    </>
  );
};
